import {basis} from "./basis";

export default function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-interpolate/src/basisClosed.js
// module id = 493
// module chunks = 0